export const lazyload = {
    mounted(el) {
      function loadImage() {
        if (el.dataset.src) {
          el.src = el.dataset.src
          el.removeAttribute('data-src')
        }
      }
  
      function handleIntersect(entries, observer) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            loadImage()
            observer.unobserve(el)
          }
        })
      }
  
      function createObserver() {
        const options = {
          root: null,
          threshold: 0,
          rootMargin: '50px' // 提前50px加载
        }
        const observer = new IntersectionObserver(handleIntersect, options)
        observer.observe(el)
      }
  
      // 如果浏览器支持 Intersection Observer
      if ('IntersectionObserver' in window) {
        createObserver()
      } else {
        // 降级处理：直接加载图片
        loadImage()
      }
    }
  }